































































































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import {
  FirewareCommonReq,
  geFirewares,
  createFireware,
  updateFireware,
  deleteFireware,
  geFirewareTypes,
} from "@/api/fireware";
import { RouteConfig } from "vue-router";
import { ResCode, Fireware, MeterType, FirewareType } from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { ElStep } from "element-ui/types/step";
import { getQiniuToken } from "@/api/admin";
import { meterTypes, MeterTypeReq } from "@/api/meter";
import * as uuid from "uuid";
import { getLanguage } from "@/utils/auth";
/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({})
export default class AddFireware extends Vue {
  private uploadQiniuUrl: string = "https://up-z2.qiniup.com"; // 七牛云服务器地址
  private fileUrl = "";
  private fileList = [];
  private fireware: Fireware = <Fireware>{};
  private firmwareTypes: FirewareType[]= [
    // "water",
    // "power",
    // "gas",
    // "hot",
    // "pv",
    // "gateway",
    // "gateway_wifi",
    // "cert",
    // "ca_cert",
    // "client_cert",
    // "client_key",
    // "pcs_ca_ert"
  ];
  private qiniuData = {
    key: "", // 图片名字处理
    token: "", // 七牛云token
    domain: "",
  };
  private beforeUploadGetKey(f1, f2) {
    this.qiniuData.key = "meter/fireware/" + uuid.v1();
  }
  private successUploadGetKey(response, file, fileList) {
    this.fileUrl = this.qiniuData.domain + "/" + this.qiniuData.key;
    this.$notify({
      title: this.$t("common.success").toString(),
      message: this.$t("notification.UploadSuccess").toString(),
      type: "success",
      duration: 2000,
    });
    this.fireware.url = this.fileUrl;
  }
  private loading = false;

  public async addFireware() {
    let req: FirewareCommonReq = <FirewareCommonReq>{};
    req.fireware = this.fireware;
    const res = await createFireware(req);
    if (!!res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.AddFirewareSuccess").toString(),
        type: "success",
      });
      this.$router.push("/meter/firewareList");
    }
  }
  public reset() {
    this.fireware = <Fireware>{};
  }

  public async qiniuToken() {
    const res = await getQiniuToken();
    if (res && res.code === ResCode.SUCCESS) {
      this.qiniuData.token = res.data.token;
      this.qiniuData.domain = res.data.domain;
    }
  }
  private meterTypes: MeterType[] = [];
  private async created() {
    let meterArray = this.$t("meterTypeArray");
    let meterTypeResponse = await meterTypes(<MeterTypeReq>{});
    if (meterTypeResponse.data.meterTypes.list.length > 0) {
      meterTypeResponse.data.meterTypes.list.push(<MeterType>{ id: 7 });
    }
    for (let i = 0; i < meterTypeResponse.data.meterTypes.list.length; i++) {
      let meterType: MeterType = <MeterType>{
        id: meterTypeResponse.data.meterTypes.list[i].id,
        name: meterArray[meterTypeResponse.data.meterTypes.list[i].id - 1],
      };
      this.meterTypes.push(meterType);
    }
    console.log("created", this.meterTypes);
    this.qiniuToken();

    let getFirewareTypesdata = await geFirewareTypes()
    this.firmwareTypes = getFirewareTypesdata.data
  }
}
